export default {
  invoice_form: {
    input_nit: {
      label: 'Cédula:',
      placeholder: 'Ingresa una cédula',
      error: {
        required: 'El campo cédula es requerido',
        format: 'Debe especificar una cédula válida'
      }
    }
  }
}
